import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";
import AddIcon from "@mui/icons-material/Add";
import BlockIcon from "@mui/icons-material/Block";
import { ButtonBase } from "@mui/material";

const RESOURCES = Resources.Paypoint;

type AddPaypointButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
};

export const AddPaypointButton = ({
  onClick,
  disabled,
}: AddPaypointButtonProps) => {
  const { t } = useResource();

  return (
    <PrimaryPaper
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 64,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px dashed",
        borderColor: "divider",
        color: "divider",
        borderRadius: 3,
        background: "none",
        boxShadow: "none",
        cursor: disabled ? "default" : "pointer",
        p: 0,
        transition: "all 0.2s",
        "&:hover": disabled
          ? {
              borderColor: "error.main",
              color: "error.main",
            }
          : {
              borderColor: "primary.main",
              color: "primary.main",
            },
      }}
      component={ButtonBase}
      onClick={disabled ? undefined : onClick}
      tabIndex={0}
      aria-label={t(RESOURCES.AddPaypointButton)}
    >
      {disabled ? (
        <BlockIcon sx={{ fontSize: 32 }} />
      ) : (
        <AddIcon sx={{ fontSize: 32 }} />
      )}
    </PrimaryPaper>
  );
};
